__turbopack_context__.v({
  "frame": "FdyUbq_frame",
});
